import React from "react";
import { Smartphone, ShoppingBag, Sandwich, ArrowRight } from "lucide-react";
import { ORDER_URL } from "../data/site";

const ITEMS = [
  {
    icon: Smartphone,
    title: "Order Ahead",
    desc: "Skip the line and order from your phone.",
  },
  {
    icon: ShoppingBag,
    title: "Pickup Fast",
    desc: "We'll have your order ready when you arrive.",
  },
  {
    icon: Sandwich,
    title: "Fresh Every Time",
    desc: "Hot, fresh, and made just for you.",
  },
];

export default function OrderSection() {
  return (
    <section
      id="order"
      data-testid="order-section"
      className="bg-[#5FBDD6] py-10 sm:py-12"
      style={{
        backgroundImage:
          "linear-gradient(135deg, #5FBDD6 0%, #3FA8C4 50%, #5FBDD6 100%)",
      }}
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-center">
        <div className="lg:col-span-9 grid grid-cols-1 sm:grid-cols-3 gap-6">
          {ITEMS.map(({ icon: Icon, title, desc }) => (
            <div
              key={title}
              data-testid={`order-feature-${title.toLowerCase().replace(/\s+/g, "-")}`}
              className="flex items-center gap-4 text-white"
            >
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-white/15 ring-1 ring-white/20">
                <Icon size={22} />
              </span>
              <div>
                <div className="font-display text-xl uppercase tracking-tight leading-none">
                  {title}
                </div>
                <p className="text-white/85 text-sm mt-1 leading-snug">
                  {desc}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="lg:col-span-3 flex lg:justify-end">
          <a
            href={ORDER_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="start-your-order-btn"
            className="group inline-flex items-center gap-2 rounded-full bg-[#A3D900] hover:bg-[#8ebf00] text-[#0B0B0B] font-extrabold tracking-[0.18em] uppercase px-8 py-4 text-sm transition-all shadow-[0_10px_30px_rgba(0,0,0,0.25)]"
          >
            Start Your Order
            <ArrowRight
              size={16}
              className="transition-transform group-hover:translate-x-1"
            />
          </a>
        </div>
      </div>
    </section>
  );
}
